module.exports = __webpack_public_path__ + "media/images/recipes/pulled_pork-24508d816425173fd92e7c4e39e9bd80.pdf";